/*--------------------overview 数据-----------------*/

export enum OverviewStatus {
  /** 未回应 */
  NoResponse = 1,
  /** 部分支持 */
  PartialSupported = 2,
  /** 拒绝提供 */
  RejectProvide = 3,
  /** 全部丢失 */
  AllLost = 4,
  /** 已冻结 */
  Freezed = 5,
  /** 提供下一个地址 */
  ProvidedNextAddress = 6,
  /** 完全提供 */
  FullyProvided = 7,
}
export interface Overview {
  entityName: string;
  logo: string;
  twitterUrls: string;
  telegramUrls: string;
  totalBlockFunds: string;
  totalReportFunds: string;
  totalLostFunds: string;
  fundingAwaitResponse: string;
  lastResponseTime: number;
  actionedReportNum: string;
  noResponseReportNum: string;
  totalEstBounty: string;
  totalContributorNum: string;
  totalReportsNum: string;
  firstReporterRewardPercent: string;
  entityRewardPercent: string;
  reportFund1: string;
  reportFund2: string;
  reportFund3: string;
  blockFund1: string;
  blockFund2: string;
  blockFund3: string;
  status: OverviewStatus;
}

/*-----------------Verified Report 列表数据 -------------------*/

export enum ReportStatus {
  Blocked = 1,
  Loss = 2,
  Partial_Blocked = 3,
  Reject_Support = 4,
  No_Response = 5,
  PROVIDED_NEXT_ADDRESS = 6,
  PARTIALLY_ADDRESSED = 7,
}

export interface Report {
  reporterAddress: string;
  reportTime: string;
  fundAmount: string;
  contactEntityTime: number;
  entityResponseTime?: number;
  entityUserAddress: string;
  estBounty: string;
  status: ReportStatus;
  blockedFunds: string;
  lostFunds: string;
  backOnChainFunds: string;
  txHash: string;
  reportFile: string;
  reportText: string;
  entityName: string;
  logo: string;
  reporterName?: string;
}

/*-----------------Contributor 列表数据 -------------------*/
export interface Contributor {
  ranking: number;
  reportAddress: string;
  verifiedReportNum: number;
  reportFunds: string;
  blockFunds: string;
  estBounty: string;
  reporterName: string;
}
